export default {"src":"/_next/static/media/loader.8f352b43.gif","height":696,"width":840,"blurWidth":0,"blurHeight":0};